export default __webpack_public_path__ + "static/media/BodyYellow_diffuse-min.76adc4be.jpg";